// extracted by mini-css-extract-plugin
module.exports = {"header":"Home_header__2nD6J","headerImg":"Home_headerImg__1M_Ld","heading":"Home_heading__1zdrE","subhead":"Home_subhead__1lxNV"};